/**
 * Needs to be kept in sync with DB enum values.
 */
export const lotGarageHandlingValues = ["left", "right"] as const;
export type LotGarageHanding = (typeof lotGarageHandlingValues)[number];

/**
 * Needs to be kept in sync with DB enum values.
 */
export const lotSpecValues = ["none", "spec", "model"] as const;
export type LotSpec = (typeof lotSpecValues)[number];

/**
 * Needs to be kept in sync with DB enum values.
 */
export const lotStatusValues = ["available", "unavailable", "pending", "sold", "closed"] as const;
export type LotStatus = (typeof lotStatusValues)[number];

/** Lot statuses that mean a unit Home Plan has progressed past preparation (mirrors UnitPlanStatus phases). */
const unitHomePlanLockableLotStatusValues = ["pending", "sold", "closed"] as const satisfies readonly LotStatus[];

export function lotStatusAllowsUnitLock(lotStatus: LotStatus | undefined): boolean {
  if (!lotStatus) {
    return false;
  }
  return (unitHomePlanLockableLotStatusValues as readonly LotStatus[]).includes(lotStatus);
}
